import { mapGetters } from 'vuex';
import mInput from '@/components/lots/otpAdvance';
import MSelect from '@/components/lots/otpSelect2';
import LotsSelect from '@/components/lots/lotsSelect/Index.vue';
import AddrCascader from '../../../../../views/resource/transportPortrait/components/AddrCascader/index.vue';
import AddressSelect from './components/AddressSelectPlus.vue';
import srmAdvance from '../../../../../components/srmAdvance/index.vue'
import { dictWithUrl } from '@/components/otpPanel/api';
import { listCompanyBySiteCodes, changeBusinessScaleEnable, matchDigitalValueValidRule } from '../../../../../api/bidScheme.js';
import { BID_STATUS, BUSINESS_TYPE } from '../../../../../constant/constant.js';
import { accountAdvanceConfig } from '../../../../../constant/advanceConfig.js';
import dayjs from 'dayjs'

const ruleDeposit = (rule, value, callback) => {
    if (!value || value * 1 <= 0) {
        callback(new Error('必须大于0'));
    } else {
        callback();
    }
};

const ruleBusinessScale = (rule, value, callback) => {
    const num = 10000;
    if (isNaN(Number(value)) || Number(value) < num) {
        callback(new Error(`业务规模不低于${num}元`));
    } else {
        callback();
    }
};

const rulePriceProportion = (rule, value, callback) => {
    if (value * 1 < 0) {
        callback(new Error('必须大于0'));
    } else {
        callback();
    }
};

export const carTypeAdvConfig = {
    prop: 'lengthNameCn',
    name: '主发车型',
    value: 'lengthNameCn',
    type: 'advance',
    unfold: true,
    searchRequired: true,
    advanceConfig: [
        { prop: 'actualVechile', value: '车型' },
        { prop: 'cdegCode', value: '车型编码' },
    ],
    tableConfig: [
        { prop: 'cdegCode', value: '车型编码' },
        { prop: 'actualVechile', value: '车型' },
    ],
    prefix: '/api-srm-web',
    advanceUrl: '/supplier/dcApi/cdTsEquipmentGroupSearch',
    cbParams: ['cdegCode#lengthList', 'actualVechile#lengthNameCn'],
    span: 3,
    // advanceCascade: 'status',
    multiple: true,
    multipleDelConfirm: true,
    max: 10,
    default: true,
    multipleTableColumn: { prop: 'actualVechile', value: '车型' }
}

const customerParams = {
    name: '客户',
    value: 'customerName',
    advanceLabel: '客户弹出框',
    advanceConfig: [
        { prop: 'ebcuNameCn', value: '客户名称' },
        { prop: 'pmCode', value: '客户编码' }
    ],
    tableConfig: [
        { prop: 'ebcuNameCn', value: '客户名称' },
        { prop: 'pmCode', value: '客户编码' }
    ],
    advanceUrl: '/ebCustomer/searchByEbCustomer',
    cbParams: ['pmCode#customerCode', 'ebcuNameCn#customerName'],
    multiple: true,
    multipleTableConfig: [{ prop: 'pmCode', value: '客户编码' }, { prop: 'ebcuNameCn', value: '客户名称' }],
    max: 20
}
//联合招标分公司
const jointBiddingCompany = {
    name: '联合招标分公司',
    value: 'unionBidCompanyName',
    advanceLabel: '分公司弹出框',
    advanceConfig: [
        { prop: 'companyNameCn', value: '分公司名称' },
        { prop: 'companyCode', value: '分公司编码' }
    ],
    tableConfig: [
        { prop: 'companyNameCn', value: '分公司名称' },
        { prop: 'companyCode', value: '分公司编码' }
    ],
    advanceUrl: '/esCompany/popCompany',
    cbParams: ['companyCode#unionBidCompanyCode', 'companyNameCn#unionBidCompanyName'],
    multiple: true,
    multipleTableConfig: [{ prop: 'companyCode', value: '分公司编码' }, { prop: 'companyNameCn', value: '分公司名称' }],
    max: 20
}

// const aadd = '135-13502-1350213-1350213005,135-13502-1350213-1350213006'
// const aadd = [
//     {
//         province: '135',
//         city: ['13502'],
//         district: ['1350213'],
//         street: ['1350213005'],
//     },
//     ['135', '13502', '1350213', '1350213005'],
//     ['135', '13502', '1350213', '1350213006'],
//     ['136', '13605', '1360502', '1360502001'],
//     ['136', '13605', '1360502', '1360502002'],
//     ['136', '13605', '1360521', '1360521200'],
//     ['136', '13605', '1360521', '1360521202'],
// ]

export default {
    props: {
        siteFormData: {
            type: Object,
            default() {
                return {};
            }
        },
        form: {
            type: Object,
            default() {
                return {};
            }
        },
        openPerDialog: {
            type: Object,
            default() {
                return {};
            }
        },
        isPrivilege: {
            type: Boolean,
            default: false,
        }
    },
    components: { MSelect, mInput, LotsSelect, AddressSelect, AddrCascader, srmAdvance },
    data() {
        return {
            operatingCity:[],
            mainRegion:[],
            bigIndustryList: [],
            mainTransportCar:'',
            carTypeAdvConfig, // 车型
            dictData: [],
            pickerOptionsEnd: {
                disabledDate: time => { return time.getTime() <= new Date(new Date().toLocaleDateString()).getTime(); }
            },
            pickerOptionsStart: { disabledDate: time => { return time.getTime() < new Date(new Date().toLocaleDateString()).getTime(); } },
            rules: {
                companyName: [{ required: true, message: ' ', trigger: 'blur' }],
                siteName: [{ required: true, message: ' ', trigger: 'blur' }],
                signUpEndTime: [{ required: true, message: ' ', trigger: 'blur' }],
                purchaseStartTime: [{ required: true, message: ' ', trigger: 'blur' }],
                depositEndTime: [{ required: true, message: ' ', trigger: 'blur' }],
                quoteStartTime: [{ required: true, message: ' ', trigger: 'blur' }],
                currency: [{ required: true, message: ' ', trigger: 'blur' }],
                bidPrice: [{ required: true, message: ' ', trigger: 'blur' }],
                businessScale: [
                    { required: true, message: ' ', trigger: 'blur' },
                    { validator: ruleBusinessScale, trigger: 'blur' },
                ],
                priceProportion: [{ required: true, validator: rulePriceProportion, trigger: 'blur' }],
                lowestQuoteVisible: [{ required: true, message: ' ', trigger: 'blur' }],
                blockPriceMaintain: [{ required: true, message: ' ', trigger: 'blur' }],
                syntheticalScore: [{ required: true, message: ' ', trigger: 'blur' }],
                skillProportion: [{ required: true, message: ' ', trigger: 'blur' }],
                businessType: [{ required: true, message: ' ', trigger: 'blur' }],
                servicesType: [{ required: true, message: ' ', trigger: 'blur' }],
                contractEffectiveTime: [{ required: true, message: ' ', trigger: ['blur'] }],
                contractSuspendTime: [{ required: true, message: ' ', trigger: ['blur'] }],
                accountEntity: [{ required: true, message: ' ', trigger: 'blur' }],
                taxRate: [{ required: true, message: ' ', trigger: 'blur' }],
                cashRation: [{ required: true, message: ' ', trigger: 'blur' }],
                oilCardRation: [{ required: true, message: ' ', trigger: 'blur' }],
                acceptanceRation: [{ required: true, validator: rulePriceProportion, trigger: 'blur' }],
                invoiceType: [{ required: true, message: ' ', trigger: 'blur' }],
                paymentTerms: [{ required: true, message: ' ', trigger: 'blur' }],
                customerType: [{ required: true, message: ' ', trigger: 'blur' }],
                blockPriceControl: [{ required: true, message: ' ', trigger: 'blur' }],
                transType: [{ required: true, message: ' ', trigger: 'blur' }],
                priceMax: [{ required: true, validator: ruleDeposit, trigger: 'blur' }],
                // specialPermitFlag: [{ required: true, message: ' ', trigger: 'blur' }],
                customerName: [{ required: true, message: ' ', trigger: 'blur' }],
                collectTypeCode: [{ required: true, message: ' ', trigger: 'blur' }],
                professionalCompany: [{ required: true, message: ' ', trigger: 'blur' }],
                priceBarb: [{ required: true, message: ' ', trigger: 'blur' }],
            },
            // 分公司
            companyNameData: {
                value: 'companyName',
                advanceConfig: [{ prop: 'companyNameCn', value: '分公司名称' }, { prop: 'companyCode', value: '分公司编码' }],
                advanceUrl: '/esCompany/popCompany',
                cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
                name: '分公司',
                tableConfig: [{ prop: 'companyCode', value: '分公司编码' }, { prop: 'companyNameCn', value: '分公司名称' }]
            },
            // 服务平台
            siteNameData: {
                value: 'siteName',
                advanceConfig: [{ prop: 'escoCompanyNameCn', value: '服务平台名称' }, { prop: 'escoCompanyNo', value: '服务平台编码' }],
                advanceUrl: '/searchPlatform?escoStatus=ENABLE',
                advancePrefix: 'web-bms',
                cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                name: '服务平台',
                tableConfig: [{ prop: 'escoCompanyNo', value: '服务平台编码' }, { prop: 'escoCompanyNameCn', value: '服务平台名称' }],
                advanceCascade: `companyCode#companyCode`
            },
            // 币种
            currencyData: {
                value: 'companyName',
                advanceConfig: [{ prop: 'currency', value: '币种代码' }, { prop: 'nameCn', value: '币种名称' }],
                advanceUrl: '/efCurrency/search',
                cbParams: ['currency#companyCode', 'nameCn#companyName'],
                name: '币种',
                tableConfig: [{ prop: 'currency', value: '币种代码' }, { prop: 'nameCn', value: '币种名称' }]
            },
            // 会计主体
            accountEntityData: {
                ...accountAdvanceConfig,
                value: 'operatingUnitName',
                advanceConfig: [{ prop: 'operatingUnitId', value: '业务实体代码' }, { prop: 'operatingUnitName', value: '业务实体名称' }, { prop: 'companyName', value: '公司名称' }],
                tableConfig: [{ prop: 'operatingUnitId', value: '业务实体代码' }, { prop: 'operatingUnitName', value: '业务实体名称' }, { prop: 'companyName', value: '公司名称' }],
                cbParams: ['operatingUnitId', 'operatingUnitName', 'companyName', 'legalEntityName']
            },
            taxRateData: {// 税率
                value: 'percentageRate',
                name: '税率',
                advanceConfig: [{ prop: 'taxRateCode', value: '税率编码' }],
                tableConfig: [{ prop: 'taxRateCode', value: '税率编码' }, { prop: 'percentageRate', value: '税率名称' }],
                advanceUrl: '/efTaxRate/popTaxRate/in',
                cbParams: ['percentageRate', 'taxRateCode']
            },
            customerParams,
            jointBiddingCompany,
            formObj: {},
            businessScaleDiasbled:false,
            customersCache: [], // 合同客户弹窗缓存
            unionBidCompanyNameCache: [], // 联合招标分公司弹窗缓存
            initState:true, //初始化页面状态
            BUSINESS_TYPE,
            matchDigitalValueValidRuleKey: '',
            matchDigitalValueValidRuleData: {
                init: false,
                validDigitalValueMsg: '',
                expression: '',
                digitalValue: '',
            },
        };
    },
    mounted() {
        dictWithUrl('SYS_COLLECT_TYPE').then(item => {
            this.dictData = item.data;
        });
    },
    computed: {
        ...mapGetters(['currentTenant', 'applicationCode', 'tenantCode']),
        isSkillProportion() {
            if (this.formObj.syntheticalScore === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        isOilCardRation() {
            if (this.formObj.businessType === '3' || this.formObj.businessType === '4' || this.formObj.businessType === '5' || this.formObj.businessType === '10') {
                return true;
            } else {
                return false;
            }
        },
        isApvSgSd() {
            const { APPROVAL, SCORING, SCORED } = BID_STATUS;
            // 标书通过、综合评分中、综合评分完成
            return [APPROVAL, SCORING, SCORED].includes(this.$store.state.bidData.bidStatus);
        },
        pickerOptionsQuoteStart(){ 
           
            return {
                disabledDate: time => { 
                    //截止时间、标书购买开始时间、保证金提交截止时间的日历只能选择比报价开始时间小的日期
                    const signUpEndTimeCheck = this.formObj.signUpEndTime ? time.getTime() < dayjs(this.formObj.signUpEndTime).startOf('day').valueOf() : false
                    const purchaseStartTimeCheck = this.formObj.purchaseStartTime ? time.getTime() < dayjs(this.formObj.purchaseStartTime).startOf('day').valueOf() : false
                    const depositEndTimeCheck = this.formObj.depositEndTime ? time.getTime() < dayjs(this.formObj.depositEndTime).startOf('day').valueOf() : false
                    return time.getTime() < new Date(new Date().toLocaleDateString()).getTime() || purchaseStartTimeCheck || depositEndTimeCheck || signUpEndTimeCheck ; 
                }
            }
        },
        pickerOptionsOhterStart(){ 
            return {
                disabledDate: time => { 
                    //报价开始时间的日历只能选择比截止时间、标书购买开始时间、保证金提交截止时间大的日期
                    const quoteStartTimeCheck = this.formObj.quoteStartTime ? time.getTime() > dayjs(this.formObj.quoteStartTime).valueOf() : false
                    return time.getTime() < new Date(new Date().toLocaleDateString()).getTime() || quoteStartTimeCheck ;
                }
            }
        },
        businessScaleMyriad() {
            const businessScale = this.formObj.businessScale
            const num = businessScale / 10000 || 0
            const parts = num.toString().split('.');
            if (parts.length === 1) return num; // 没有小数部分
            const decimalPart = parts[1].slice(0, 2);
            return `${parts[0]}.${decimalPart}`;
        },
        contractDepositRationShow({ formObj, matchDigitalValueValidRuleData }) {
            let flag = false
            try {
                const { init, expression = '', digitalValue = '' } = matchDigitalValueValidRuleData
                if (init && expression && digitalValue) {
                    const { contractDepositRation } = formObj
                    // 动态计算
                    const evalStr = `${contractDepositRation} ${expression} ${digitalValue}`;
                    console.log('expression', evalStr)
                    if (!eval(evalStr)) {
                        flag = true
                    }
                }
            } catch (error) {
                console.error('contractDepositRationShow', error)
            }
            return flag
        },
    },
    watch: {
        form: {
            handler(newValue, oldValue) {
                const { bigIndustry, mainTransportCarName,operatingCityCode,operatingCityName,mainRegion,mainRegionName } = newValue
                if (typeof bigIndustry === 'string' &&  bigIndustry.length > 0) {
                    this.bigIndustryList = newValue.bigIndustry.split(',')
                }
                if (typeof mainTransportCarName === 'string') {
                    this.mainTransportCar = mainTransportCarName
                }
                // this.operatingCity = [
                //     {value:'135-13502',label:'福建省厦门市'},
                //     {value:'135-13506',label:'福建省漳州市'},
                // ]
                // 操作城市
                if (typeof operatingCityCode === 'string' && operatingCityCode.length > 0 && typeof operatingCityName === 'string' && operatingCityName.length > 0) {
                    let codeList = operatingCityCode.split(',');
                    let nameList = operatingCityName.split(',');
                    let operatingCityList  = [];
                    for (let i = 0; i < codeList.length; i++) {
                        let row = {value:codeList[i],label:nameList[i]}
                        operatingCityList.push(row)
                    }
                    this.operatingCity = operatingCityList
                  
                }
                // 主发区域
                if (typeof mainRegion === 'string' && mainRegion.length > 0 && typeof mainRegionName === 'string' && mainRegionName.length > 0) {
                    let codeList = mainRegion.split(',');
                    let nameList = mainRegionName.split(',');
                    let mainRegionList  = [];
                    for (let i = 0; i < codeList.length; i++) {
                        let row = {value:codeList[i],label:nameList[i]}
                        mainRegionList.push(row)
                    }
                    this.mainRegion = mainRegionList
                  
                }
                if (this.initState) {
                    // bidStatus 00 标书新建
                    // bidStatus 20 标书驳回
                    
                    if (newValue.businessScale) {
                        if(newValue.bidStatus === '20'){
                            this.businessScaleDiasbled = true
                        }
                        if(newValue.bidStatus === '00'){
                            changeBusinessScaleEnable({bidNo: this.form.bidNo}).then(res => {
                                if (res && +res.code === 0) {
                                    this.businessScaleDiasbled = !res.data
                                }else{
                                    this.businessScaleDiasbled = true
                                }
                            }).catch(e => {
                                this.businessScaleDiasbled = true
                            })
                        }
                    } else {
                        this.businessScaleDiasbled = false
                    }
                    this.initState = false
                }
                this.formObj = newValue;
                const { businessType, transType, businessScale } = newValue
                this.matchDigitalValueValidRuleKey = `${businessType},${transType},${businessScale}`
                this.setCustomersCache();
                this.setJointBiddingCompanyCache();
            },
            deep: true
        },
        matchDigitalValueValidRuleKey(newValue) {
            this.getMatchDigitalValueValidRule(newValue)
        },
    },
    methods: {
        // 获取【合同押金比例（%）】label显示文案
        getMatchDigitalValueValidRule(key) {
            const { businessType, transType, businessScale } = this.formObj
            const params = {
                businessType,
                transType,
                businessScale,
                configType: 2,
            }
            this.matchDigitalValueValidRuleData.init = false
            this.matchDigitalValueValidRuleData.validDigitalValueMsg = ''
            this.matchDigitalValueValidRuleData.expression = ''
            this.matchDigitalValueValidRuleData.digitalValue = ''
            matchDigitalValueValidRule(params).then((res) => {
                if (res && res.code === '0' && key === this.matchDigitalValueValidRuleKey) {
                    // console.log('getMatchDigitalValueValidRule res', res.data)
                    const { validDigitalValueMsg = '', expression = '', digitalValue = '' } = res.data
                    this.matchDigitalValueValidRuleData.validDigitalValueMsg = validDigitalValueMsg
                    this.matchDigitalValueValidRuleData.expression = expression
                    this.matchDigitalValueValidRuleData.digitalValue = digitalValue
                    this.matchDigitalValueValidRuleData.init = true
                }
            })

        },
        getOperatingCity(data) {
            // console.log('data',data);
            const nameList = []
            const codeList = []
            if (Array.isArray(data)) {
                for (const item of data) {
                    nameList.push(item.label)
                    codeList.push(item.value)
                }
            }
            this.formObj.operatingCityCode = codeList.join(',');
            this.formObj.operatingCityName = nameList.join(',');
            // console.log('operatingCityCode',this.formObj.operatingCityCode);
            // console.log('operatingCityName',this.formObj.operatingCityName);

        },
        getMainRegion(data) {
            // console.log('data',data);
            const nameList = []
            const codeList = []
            if (Array.isArray(data)) {
                for (const item of data) {
                    nameList.push(item.label)
                    codeList.push(item.value)
                }
            }
            this.formObj.mainRegion = codeList.join(',');
            this.formObj.mainRegionName = nameList.join(',');
            // console.log('mainRegion',this.formObj.mainRegion);
            // console.log('mainRegionName',this.formObj.mainRegionName);

        },
        getMainTransportCar(data) {
            if (typeof data.lengthList === 'string') {
                this.formObj.mainTransportCar = data.lengthList
                this.mainTransportCar = data.lengthNameCn
            }
        },
        startChange(val, contractEffectiveTime) {
            this.pickerOptionsEnd = {
                disabledDate: time => {
                    if (!contractEffectiveTime) {
                        return time.getTime() < new Date(new Date().toLocaleDateString()).getTime();
                    } else {
                        return time.getTime() < new Date(new Date().toLocaleDateString()).getTime() || time.getTime() <= new Date(contractEffectiveTime).getTime();
                    }
                }
            };
        },
        getCompanyName(val) {
            this.formObj.companyCode = val.companyCode;
            this.formObj.companyName = val.companyName;
            this.siteFormData.companyCode = val.companyCode;
            this.formObj.siteCode = '';
            this.formObj.siteName = '';
        },
        getsiteName(val) {
            this.formObj.siteCode = val.siteCode;
            this.formObj.siteName = val.siteName;
            this.setCenter(val.siteCode)
        },
        // 赋值经营中心
        setCenter(siteCode) {
            if (siteCode) {
                listCompanyBySiteCodes([siteCode]).then(res => {
                    if (res && +res.code === 0 && res.data.length) {
                        this.formObj.centerCode = res.data[0].businessCode
                        this.formObj.centerName = res.data[0].businessName
                        this.formObj.companyCode = res.data[0].companyCode
                        this.formObj.companyName = res.data[0].companyName
                    } else {
                        this.formObj.centerCode = ''
                        this.formObj.centerName = ''
                        this.formObj.companyCode = ''
                        this.formObj.companyName = ''
                    }
                })
            } else {
                this.formObj.centerCode = ''
                this.formObj.centerName = ''
            }
        },
        getCurrency(val) { this.formObj.currency = val.companyCode; },
        getAccountEntity(val) {
            this.formObj.accountEntity = val.operatingUnitId;
            this.formObj.accountEntityName = val.operatingUnitName;
            this.formObj.accountCompanyName = val.legalEntityName;
        },
        getInvoiceType(val) { this.formObj.invoiceType = val; },
        getBusinessType(val) {
            if (this.formObj.businessType * 1 === val * 1) { return; }
            this.formObj.businessType = val;
            if (val === '3' || val === '4' || val === '5') {
                this.formObj.oilCardRation = 0;
            }
            if(![BUSINESS_TYPE.TRANSPORTATION_NUM, BUSINESS_TYPE.DELIVERY_NUM].includes(val)){
                this.operatingCity = []
                this.mainRegion = []
                this.formObj.operatingCityCode = '';
                this.formObj.operatingCityName = '';
                this.formObj.mainRegion = '';
                this.formObj.mainRegionName = '';
                this.formObj.mainTransportCar = ''
                this.formObj.mainTransportCarName = ''
                this.mainTransportCar = ''
            }
            this.formObj.servicesType = null;
            this.formObj.transType = null;
        },
        getServicesType(val) { this.formObj.servicesType = val; },
        getPaymentTerms(val) { this.formObj.paymentTerms = val; },
        getCustomerType(val) { this.formObj.customerType = val; },
        // 价格分权重
        cpriceProportion() { if (this.form.syntheticalScore === 'Y') { this.form.priceProportion = 100 - this.form.skillProportion * 1 - this.form.businessProportion; } },
        getSyntheticalScore(val) {
            this.formObj.syntheticalScore = val;
            if (val === 'Y') {
                this.cpriceProportion();
            } else {
                this.formObj.skillProportion = 0;
                this.formObj.businessProportion = 0;
                this.formObj.priceProportion = 100;
            }
        },
        //是否防倒挂
        getPriceBarb(val) {this.formObj.priceBarb = val; },
        getBigIndustry(val) {
            if (Array.isArray(val) && val.length > 0) {
                this.formObj.bigIndustry = val.join(',')
            } else {
                this.formObj.bigIndustry = ''
            }
        },
        getSpecialPermitFlag(val) { this.formObj.specialPermitFlag = val; },
        getProfessionalCompany(val) { this.formObj.professionalCompany = val; },
        getBlockPriceControl(val) { this.formObj.blockPriceControl = val; },
        getLowestQuoteVisible(val) { this.formObj.lowestQuoteVisible = val; },
        getTransType(val) { this.formObj.transType = val; },
        getTaxRate(val) { this.formObj.taxRate = val.percentageRate; },
        getRalationQuote(val) { this.formObj.ralationQuote = val; },
        getNeedCollect(val) {
            this.$set(this.form, 'needCollect', val);
            if (+val === 0) {
                this.$set(this.form, 'collectTypeCode', []);
            }
        },
        getCollectTypeCode(val) {
            const arr = [];
            val.forEach(el => {
                arr.push(this.dictData.SYS_COLLECT_TYPE[el]);
            });
            const str = arr.join(',');
            this.$set(this.form, 'collectTypeCode', val);
            this.$set(this.form, 'collectTypeName', str);
        },
        // 组织者
        detailOrganizerName() { this.openPerDialog.showDialog = true; this.openPerDialog.checkedList = [{ userCode: this.formObj.organizerCode }]; },
        cAcceptanceRation() { this.formObj.acceptanceRation = 100 - this.formObj.cashRation - this.formObj.oilCardRation; }, // 承兑比例
        // 移除校验结果
        depositValueChange(val) {
            this.$refs.form.clearValidate([val]);
        },
        getCustomerNameName(val) {
            this.formObj.customerCode = val.customerCode;
            this.formObj.customerName = val.customerName;
            if (val.customerCode) {
                const customerNames = val.customerName.split(',')
                this.formObj.customers = val.customerCode.split(',').map((code, index) => {
                    return {
                        customerCode: code,
                        customerName: customerNames[index],
                    }
                });
            } else {
                this.formObj.customers = []
            }
        },
        setCustomersCache() {
            if (this.formObj.customers && this.formObj.customers.length) {
                this.customersCache = this.formObj.customers.map(item => {
                    return {
                        pmCode: item.customerCode,
                        ebcuNameCn: item.customerName,
                    }
                });
            } else {
                this.customersCache = []
            }
        },
        getJointBiddingCompany(val) {
            this.formObj.unionBidCompanyCode = val.unionBidCompanyCode;
            this.formObj.unionBidCompanyName = val.unionBidCompanyName;
            if (val.unionBidCompanyCode) {
                const companyNameList = val.unionBidCompanyName.split(',')
                this.formObj.unionBidCompanyList = val.unionBidCompanyCode.split(',').map((code, index) => {
                    return {
                        customerCode: code,
                        customerName: companyNameList[index],
                    }
                });
            } else {
                this.formObj.unionBidCompanyList = [];
                this.formObj.unionBidCompanyCode = "";
                this.formObj.unionBidCompanyName = "";
            }
        },
        setJointBiddingCompanyCache() {
            if (this.formObj.unionBidCompanyList && this.formObj.unionBidCompanyList.length) {
                this.unionBidCompanyNameCache = this.formObj.unionBidCompanyList.map(item => {
                    return {
                        companyCode: item.customerCode,
                        companyNameCn: item.customerName,
                    }
                });
            } else {
                this.unionBidCompanyNameCache = [];
                // this.formObj.unionBidCompanyCode = "";
                // this.formObj.unionBidCompanyName = "";
            }
        },
    }
};